export default __webpack_public_path__ + "static/media/di8.b3800f70.jpg";